import styled from "styled-components";

export const UploadContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`;

export const ImagePreview = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`;

export const UploadField = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    input {
        width: 100%;
    }
`;

export const PhotoButtons = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
`;

export const PhotoButton = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    label {
        width: 100%;
    }
`;
